import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import ErrorFallbackView from "./ErrorFallbackView";

const RouteErrorFallback: React.FC = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    navigate(ROUTES.LANDING_PAGE);
  };

  return (
    <ErrorFallbackView
      error={error}
      onRefresh={handleRefresh}
      onGoHome={handleGoHome}
    />
  );
};

export default RouteErrorFallback;
